import { render, staticRenderFns } from "./NoteDetail.vue?vue&type=template&id=5451177c&scoped=true&"
import script from "./NoteDetail.vue?vue&type=script&lang=js&"
export * from "./NoteDetail.vue?vue&type=script&lang=js&"
import style0 from "./NoteDetail.vue?vue&type=style&index=0&id=5451177c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5451177c",
  null
  
)

export default component.exports